import React from 'react';
import T from 'prop-types';
// icons
import { ReactComponent as ReloadIcon } from 'icons/reload.svg';
// styles
import classnames from 'classnames/bind';
import styles from './Button.module.scss';

const cx = classnames.bind(styles);

const VARIANTS = ['primary', 'light', 'grey'];

const ReloadButton = ({ onClick, variant = 'primary', className, ...props }) => {
  return (
    <div role="button" className={cx('reload-button', `bg-${variant}`, className)} onClick={onClick} {...props}>
      <ReloadIcon />
    </div>
  );
};

ReloadButton.propTypes = {
  onClick: T.func.isRequired,
  variant: T.oneOf(VARIANTS),
  className: T.string,
};

export default ReloadButton;
